import React from 'react';
import { offerAnchor, protocolStructure, sampleMeta, sampleTimeline } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-130" data-mp="21mhff462dlfw">
      <div className="mx-auto max-w-3xl" data-id="element-131" data-mp="25o303boub40n">
        <Eyebrow data-id="element-132" data-mp="25n1dc9ygot33">Look inside</Eyebrow>
        <SectionTitle data-id="element-133" data-mp="1rx7q1w2lugvh">
          See how a complete rehabilitation <Mark data-id="element-134" data-mp="1rvmuq48gutwk">session is organized</Mark>
        </SectionTitle>

        <article className="mt-8 overflow-hidden rounded-2xl border border-teal-800/10 bg-white shadow-xl" data-id="element-135" data-mp="1wo7kmuo94mut">
          <header className="bg-teal-800 p-5" data-id="element-136" data-mp="1i02zlk1q7z8v">
            <p className="text-[10px] font-extrabold uppercase tracking-wider text-amber-300" data-id="element-137" data-mp="1hx70vti216jd">Example session</p>
            <h3 className="mt-1 text-base font-black uppercase text-white md:text-lg" data-id="element-138" data-mp="18yd70aw3yu9i">
              30-Minute Functional Rehabilitation Session
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-white/85" data-id="element-139" data-mp="1dwwy0ppk6w8q">
              An illustrative session for an appropriately assessed older adult with difficulty rising from a chair and
              reduced lower-limb control.
            </p>
          </header>
          <dl className="grid gap-px bg-teal-800/10 sm:grid-cols-3" data-id="element-140" data-mp="k13yp2i93qul">
            {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-141" data-mp="f32bc5dsl5db">
                <dt className="text-[10px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-142" data-mp="3nhaygxxjp3y3">{label}</dt>
                <dd className="mt-0.5 text-sm font-bold text-teal-950" data-id="element-143" data-mp="3iiznukzfepet">{value}</dd>
              </div>)}
          </dl>
          <div className="border-t border-teal-800/10 px-5 pt-4" data-id="element-144" data-mp="13kklkgxri1b">
            <p className="text-[11px] font-black uppercase tracking-wider text-teal-700" data-id="element-145" data-mp="3sg5k07mwd6lw">Session stage</p>
            <table className="mt-2 w-full text-left text-sm" data-id="element-146" data-mp="34qb41h7a71xf">
              <thead className="sr-only" data-id="element-147" data-mp="34oqds3s0255d">
                <tr data-id="element-148" data-mp="2zqykp6fmcczl">
                  <th scope="col" data-id="element-149" data-mp="2zrgmeil1vjew">Session stage</th>
                  <th scope="col" data-id="element-150" data-mp="13p3lhzcokaoa">Time</th>
                </tr>
              </thead>
              <tbody data-id="element-151" data-mp="18nya5hxbwtgb">
                {sampleTimeline.map(([stage, time]) => <tr key={stage} className="border-b border-teal-800/10" data-id="element-152" data-mp="18ltwi89mog2u">
                    <th scope="row" className="py-2.5 pr-3 align-top font-semibold text-teal-950" data-id="element-153" data-mp="1df6jyf2kmgu0">
                      {stage}
                    </th>
                    <td className="whitespace-nowrap py-2.5 text-right font-bold tabular-nums text-teal-700" data-id="element-154" data-mp="kq95yo5e7672">{time}</td>
                  </tr>)}
                <tr data-id="element-155" data-mp="pr6juojdde2r">
                  <th scope="row" className="py-3 pr-3 text-xs font-black uppercase tracking-wider text-teal-950" data-id="element-156" data-mp="tqnq3k6mef8z">
                    Total
                  </th>
                  <td className="whitespace-nowrap py-3 text-right font-black tabular-nums text-teal-950" data-id="element-157" data-mp="yrbows13c0dr">30 min</td>
                </tr>
              </tbody>
            </table>
            <p className="pb-4 text-xs italic leading-relaxed text-slate-600" data-id="element-158" data-mp="2a3w5qghbjtl9">
              Treatment must be individualized according to patient assessment and clinical response.
            </p>
          </div>
          <div className="border-t border-teal-800/10 bg-slate-50 px-5 py-4" data-id="element-159" data-mp="2fb2mt3lirmok">
            <p className="text-[11px] font-black uppercase tracking-wider text-teal-950" data-id="element-160" data-mp="2ai9iuhxvkidj">
              Each protocol provides practical guidance on:
            </p>
            <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-161" data-mp="21icy2relw3nr">
              {protocolStructure.map(item => <li key={item} className="rounded-md border border-teal-800/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-700" data-id="element-162" data-mp="1wjjhgq40vwjd">
                  {item}
                </li>)}
            </ul>
          </div>
        </article>

        <div className="mt-10 text-center" data-id="element-163" data-mp="3lx6hmjjv2ly3">
          <h3 className="mx-auto max-w-2xl text-xl font-black uppercase leading-tight text-teal-950 md:text-2xl" data-id="element-164" data-mp="3lw3pk8asydgl">
            Imagine starting every session with a <Mark data-id="element-165" data-mp="3p0ufwer0wv4o">clear treatment plan.</Mark>
          </h3>
          <div className="mt-5" data-id="element-166" data-mp="3tyvxswcpqoek">
            <Button href={offerAnchor} size="lg" subtext="See everything included + today's launch price." data-id="element-167" data-mp="3tz5neituitjq">
              I want my rehabilitation sessions organized
            </Button>
          </div>
        </div>
      </div>
    </section>;
}